<template>
  <router-link :to="link" class="card-suporte">
    <div class="icone-area">
      <span class="icone">{{ icone }}</span>
    </div>

    <div class="conteudo">
      <h3 class="titulo">{{ titulo }}</h3>
      <p class="descricao">{{ descricao }}</p>
    </div>
  </router-link>
</template>
<script setup>
defineProps({
  titulo: String,
  descricao: String,
  icone: String,
  link: String
});
</script>

<style scoped>
/* ==============================
   CARD BASE
================================*/
.card-suporte {
  display: flex;
  flex-direction: column;
  background: var(--branco);
  border-radius: 14px;
  border: 1px solid #e0e0e0;
  text-decoration: none;
  color: var(--cinza-escuro);
  transition: all 0.25s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  min-height: 230px;
  position: relative;
}

/* Faixa lateral rosa Click */
.card-suporte::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: var(--rosa-principal);
  border-radius: 14px 0 0 14px;
}

/* Hover leve */
.card-suporte:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(255, 92, 138, 0.15);
  border-color: var(--rosa-principal);
}

/* ==============================
   ÁREA DO ÍCONE
================================*/
.icone-area {
  width: 100%;
  height: 70px;
  background: linear-gradient(180deg, #fff 0%, #f9f9f9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eaeaea;
}

.icone {
  font-size: 1.8rem;
  color: var(--rosa-principal);
}

/* ==============================
   CONTEÚDO TEXTUAL
================================*/
.conteudo {
  padding: 1.4rem 1.6rem 1.8rem;
}

.titulo {
  font-size: 1.1rem;
  font-weight: 600;
  color: #111;
  margin-bottom: 0.5rem;
  line-height: 1.3;
  transition: color 0.25s ease;
}

.descricao {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.5;
}

/* Hover refinado */
.card-suporte:hover .titulo {
  color: var(--rosa-principal);
}

/* ==============================
   RESPONSIVIDADE
================================*/
@media (max-width: 768px) {
  .icone-area {
    height: 60px;
  }
  .titulo {
    font-size: 1.05rem;
  }
  .descricao {
    font-size: 0.9rem;
  }
}
</style>
